/* eslint-disable */
// import url_config from '@/config/local.js';
// import url_config from '@/config/dev.js';
// import url_config from '@/config/staging.js';
import url_config from '@/config/prod.js';
let is_local = window.location.origin == 'http://localhost:8080'

export default {
  ...url_config,
  defaultLocale : "en",
	localeOptions : [
    {id:'de',name:'German'},
    {id:'en',name:'English'},
    {id:'id',name:'Indonesia'},
    {id:'ja',name:'Japanese'},
    {id:'ru',name:'Russian'},
    {id:'zh',name:'Chinese'}
	],
  currencyConvertApiKey: 'bad5acb83ac091bcce20',
  QISCUS_APPID: 'guestpro-nm6jdwqrtxl2',
  GMAPS_KEY: is_local ? 'AIzaSyA_u8VJElUj-vM9lpsFDEQpkyy9BgYWjco' : 'AIzaSyCNJgw0NS4P9JVexjc3XPYdbm9Xd_IZEqc',
  FLYWIRE_URL: 'https://checkout.flywire.com/flywire-payment.js',
  RAZORPAY_URL: 'https://checkout.razorpay.com/v1/checkout.js',
  STRIPE_URL: 'https://js.stripe.com/dahlia/stripe.js',
  XENDIT_COMPONENTS_URL: 'https://assets.xendit.co/components/v0.0.28/index.umd.js'
}



// WEBPACK FOOTER //
// ./src/config/index.js